/* eslint-disable
    max-len,
    no-param-reassign,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// # USAGE
// <bl-datepicker
//   date='your date object that will be bound'
//   ngModel='value of text input, will change based on date. use if you need a string representation of the date'
//   datepickerOpts='jquery-ui datepicker options'
//   justifyRight='boolean'>
// </bl-datepicker>

require('./datePicker.scss');
require('jquery-ui/ui/widgets/datepicker');

const deps = [require('../input').name];

module.exports = angular
  .module('bench.ui.form.datePicker', deps)

  .directive('blDatepicker', $filter => ({
    restrict: 'A',
    scope: {
      ngModel: '=',
      datepickerOpts: '=',
      justifyRight: '=',
    },
    require: '?ngModel',
    link(scope, elem, attrs, ngModel) {
      const $input = elem.find('input');

      if (ngModel != null) {
        ngModel.$formatters.push(date => {
          if (date) {
            return $filter('date')(date, 'MM/dd/yyyy');
          }
          return '';
        });
      }

      // extend default opts with those provided by the user
      $input.datepicker(
        angular.extend(
          {
            minDate: new Date(2005, 0, 1),
            maxDate: '+1y',
            onSelect() {
              return scope.$apply(() => {
                scope.ngModel = $input.datepicker('getDate');
                return ngModel.$setDirty();
              });
            },
            // Append the datepicker widget to the directive element rather than the body tag,
            // so that it will move with overflow:scroll elements.
            beforeShow() {
              const $datepicker = $input.datepicker('widget');
              elem.append($datepicker);

              // to justify the datepicker right if needed
              if (scope.justifyRight) {
                return $datepicker.css('right', '0');
              }
              return $datepicker.css('right', 'initial');
            },
          },

          scope.datepickerOpts || {},
        ),
      );

      // since jQuery-ui updates the id of the input, we need to capture this value
      // so that we may assign it to the label
      return (scope.id = $input.attr('id'));
    },

    controllerAs: 'vm',
    bindToController: 'true',
    controller() {},
  }));
